<template>
    <div>
        <apexchart width="95%" height="190" type="bar" :options="chartOptions" :series="series" ref="example"></apexchart>
    </div>
</template>
<script>
export default {
    name: 'column-chart',
    props: {
        data: {
            type: Array
        },
        categories: {
            type: Array
        }
    },
    data () {
        return {
            series: [{
                data: this.data
            }],
            chartOptions: {
                chart: {
                    id: 'column-chart',
                    height: '100%',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        barHeight: '50',
                        distributed: true,
                        horizontal: false,
                        dataLabels: {
                            position: 'top'
                        },
                    }
                },
                colors: ['#6785C2', '#EB6E7A', '#FD9A47', '#4FB3E8', '#FDC135', '#FF6DF0', '#A18749', '#FD3535', '#2CB97E', '#B5B5B5'],
                dataLabels: {
                    enabled: true,
                    textAnchor: 'middle',
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Nunito-Regular, sans-serif',
                        fontWeight: 'normal',
                        colors: ['#000']
                    },
                    formatter: function (val, opt) {
                        let hours = Math.floor(val / 60)
                        let minutes = val % 60

                        if (hours < 1 && minutes < 30) {
                            return minutes + 'min'
                        }

                        if (minutes > 30) {
                            return hours + 1 + 'h'
                        }

                        return hours + 'h'
                    },
                    offsetX: 0,
                    offsetY: -20
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: [],
                    labels: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: true,
                        formatter: (val) => {
                            return Math.floor(val / 60) + 'h'
                        }
                    },
                    tickAmount: 4
                },
                legend: {
                    fontSize: '12px',
                    fontFamily: 'Nunito-Regular, sans-serif',
                    fontWeight: 'normal',
                    horizontalAlign: 'left',
                    itemMargin: {
                        vertical: 0
                    },
                    markers: {
                        radius: 100,
                        width: 10,
                        height: 10
                    }
                },
                tooltip: {
                    x: {
                        show: true
                    },
                    y: {
                        show: true,
                        formatter: function(val) {
                            if (val === 0) {
                                return val + 'min'
                            }

                            let hours = Math.floor(val / 60)
                            let minutes = val % 60
                            hours = hours !== 0 ? hours + 'h ': ''
                            minutes = minutes !== 0 ? minutes + 'min': ''

                            return hours + minutes
                        },
                        title: {
                            formatter: function (val) {
                                return ''
                            }
                        }

                    }
                }
            }
        }
    },
    methods: {
        updateSeries () {
            ApexCharts.exec('column-chart', 'updateSeries', [
                {
                    data: this.data
                }
            ])
        },
        updateXaxis () {
            ApexCharts.exec('column-chart', 'updateOptions', {
                xaxis: {
                    categories: this.categories
                }
            })
        }
    },
    watch: {
        data: {
            handler: 'updateSeries'
        },
        categories: {
            handler: 'updateXaxis'
        }
    },
    beforeDestroy () {
        this.$refs.columnChart.$destroy()
    }
}
</script>
